type MaxValuesReturn = {
  maxScrollLeft: number;
  maxThumbLeft: number;
};

export const getValueWithinMaxMin = (value: number, max: number, min: number = 0): number =>
  Math.max(Math.min(value, max), min);

export const getMaxValues = (
  thumbWidth: number,
  { scrollWidth, offsetWidth }: HTMLElement
): MaxValuesReturn => {
  const maxScrollLeft = scrollWidth - offsetWidth;
  const maxThumbLeft = offsetWidth - thumbWidth;
  return { maxScrollLeft, maxThumbLeft };
};
